import { render, staticRenderFns } from "./peoReader.vue?vue&type=template&id=c02b6458&scoped=true&"
import script from "./peoReader.vue?vue&type=script&lang=js&"
export * from "./peoReader.vue?vue&type=script&lang=js&"
import style0 from "./peoReader.vue?vue&type=style&index=0&id=c02b6458&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c02b6458",
  null
  
)

export default component.exports